"use strict";

var _interopRequireWildcard = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
var _vue = _interopRequireDefault(require("vue"));
var _axios = _interopRequireDefault(require("axios"));
var _router = _interopRequireDefault(require("../router"));
var _elementUi = require("element-ui");
var _store = _interopRequireDefault(require("@/store"));
var _auth = require("@/utils/auth");
var wlUtils = _interopRequireWildcard(require("@/utils/wl-utils"));
var _eventBus = require("@/layout/components/event-bus");
// 全局方法挂载
_vue.default.prototype.$axios = _axios.default;
_axios.default.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';

// 创建axios实例
var service = _axios.default.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 50000
});

// request拦截器
service.interceptors.request.use(function (config) {
  if ((0, _auth.getToken)() && !config.isJmReport) {
    config.headers.Authorization = 'Bearer ' + (0, _auth.getToken)(); // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config;
}, function (error) {
  // eslint-disable-next-line no-console
  console.log(error);
  Promise.reject(error);
});

// 响应拦截器
service.interceptors.response.use(function (response) {
  /* 服务器响应成功，且服务器状态码为200 */
  if (response.status === 200) {
    // console.log('service.interceptors.response.use: \n', response)

    // 记录当前请求信息，为下一次请求提供前车之鉴
    // sessionStorage.setItem('last-time-response', JSON.stringify(response))

    var res = response.data;
    var code = res.code;

    // console.log(code, res)

    if (res && res instanceof Blob) {
      /* 请求返回文件二进制流 */
      _elementUi.Notification.success({
        title: '开始下载文件'
      });
      return response;
    } else if (typeof code === 'undefined') {
      return response.data;
    } else if (code !== 200) {
      /* 当请求结果状态不为 200 */

      // 是否需要默认提示
      response.noDefaultHint = false;

      /* 延时是为了让后续代码先执行 */
      setTimeout(function () {
        if (!response.noDefaultHint) {
          if ((code + '')[0] === '5') {
            /* 服务器返回 5xx 代码 */

            // eslint-disable-next-line no-console
            console.group('服务器请求错误');
            var r = !res.message || res.message && res.message.indexOf('Exception') > 0; // 判断是否是后端抛出的默认错误

            (0, _elementUi.Notification)({
              title: r ? '服务器请求出错，请联系管理员处理' : '',
              message: r ? '' : res.message,
              type: 'error',
              duration: 10 * 1000,
              onClick: function onClick() {
                _eventBus.EventBus.$emit('open-dialog', true);
                _eventBus.EventBus.$emit('error-message', res.message + res.data);
              }
            });

            // eslint-disable-next-line no-console
            console.error('服务器请求出错', res.message);

            // eslint-disable-next-line no-console
            console.groupEnd();
            // console.log('response', response)
          } else if (code === 401) {
            /* 服务器返回 401 代码 */
            if (_router.default.currentRoute.meta.showType !== '20') {
              wlUtils.debounce(function () {
                _elementUi.MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
                  confirmButtonText: '重新登录',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(function () {
                  _store.default.dispatch('LogOut').then(function () {
                    location.replace("/login?redirect=".concat(location.pathname));
                    // location.reload() // 为了重新实例化vue-router对象 避免bug
                  });
                });
              }, 1000, true);
            }
          } else {
            (res === null || res === void 0 ? void 0 : res.message) && _elementUi.Notification.error({
              message: res.message,
              onClick: function onClick() {
                _eventBus.EventBus.$emit('open-dialog', true);
                _eventBus.EventBus.$emit('error-message', res.message + res.data);
              }
            });
          }
        }
      }, 10);
      return Promise.reject(response);
    }
    return res;
  } else {
    sessionStorage.setItem('response-status', response.status);
    (0, _elementUi.Notification)({
      title: '服务器请求出错，请联系管理员处理',
      type: 'error',
      duration: 5 * 1000,
      onClick: function onClick() {
        _eventBus.EventBus.$emit('open-dialog', true);
        _eventBus.EventBus.$emit('error-message', response.data.message + response.data.data);
      }
    });
  }
  return response;
}, function (error) {
  var err = error.request;
  // eslint-disable-next-line no-console
  console.group('后台响应出错：');
  // eslint-disable-next-line no-console
  console.log((0, _objectSpread2.default)({}, error));
  var msg = error.message;
  if (parseInt(err.status / 100, 10) === 5) {
    msg = '服务器请求出错，请联系管理员处理';
  }
  (0, _elementUi.Message)({
    message: msg,
    type: 'error',
    duration: 5 * 1000
  });
  (0, _elementUi.Notification)({
    message: '点击查看异常详情',
    type: 'error',
    duration: 5 * 1000,
    onClick: function onClick() {
      _eventBus.EventBus.$emit('open-dialog', true);
      _eventBus.EventBus.$emit('error-message', error.message + error.data);
    }
  });
  // eslint-disable-next-line no-console
  console.groupEnd();
  return Promise.reject(error);
});
var _default = exports.default = service;